export default __webpack_public_path__ + "static/media/9osish.3e3add98.webp";